import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageShellBg, resolveShellBgFromPathname } from "./pageShellBg";

/** App 级：每次 pathname 变化立即刷 body 背景（不依赖具体页面是否已 mount） */
export function useRouteShellBgSync(): void {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const { bg, front } = resolveShellBgFromPathname(pathname);
    applyPageShellBg({ bg, front });
  }, [pathname]);
}
